import getQueues from '../api/getQueues';
import getQueue from './getQueue';
import { serviceState } from './state';

export default async function refreshQueues(): Promise<void> {
  const freshQueues = await getQueues();
  serviceState.queues = freshQueues.map((q) => {
    const existing = getQueue(q.id);
    if (!existing || (!existing.status && !existing.sessions?.length)) return q;
    return {
      ...q,
      ...(existing.status && { status: existing.status }),
      ...(existing.sessions?.length && { sessions: existing.sessions }),
    };
  });
}
